import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { setToken } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const returnedState = params.get('state');
    const errorParam = params.get('error');
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUri = window.location.origin + '/auth/google';

    let savedState = null;
    try { savedState = sessionStorage.getItem('oauth_state'); sessionStorage.removeItem('oauth_state'); } catch { /* noop */ }

    if (errorParam || !code) {
      navigate('/', { replace: true });
      return;
    }
    if (savedState && returnedState && savedState !== returnedState) {
      toast.error('Sign-in could not be verified. Please try again.');
      navigate('/', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post('/auth/google', { code, redirect_uri: redirectUri });
        if (res.data?.session_token) setToken(res.data.session_token);
        setUser(res.data.user);
      } catch (e) {
        console.error('google session exchange failed', e);
        if (e.response?.status === 403) {
          toast.error(e.response?.data?.detail || 'CurbAlert is only available in the United States, Canada, and Mexico.', { duration: 8000 });
        } else {
          toast.error(e.response?.data?.detail || 'Sign-in failed. Please try again.');
        }
      } finally {
        window.history.replaceState({}, '', '/');
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-brand-paper" data-testid="auth-callback">
      <div className="font-display text-2xl text-brand-ink">Signing you in…</div>
    </div>
  );
}
